<template>
	<div>
		<div class="wrapper1200" style="display: flex;margin-top: 20px;">
			<div class="classification">
				<div class="singleType" :class="typeIndex==0?'active':''" @click="typeIndex=0">个人资料</div>
				<div class="singleType" :class="typeIndex==1?'active':''" @click="typeIndex=1">意见反馈</div>
				<div class="singleType" :class="typeIndex==2?'active':''" @click="typeIndex=2">设置</div>
			</div>
			<div class="diagnosis" v-if="typeIndex==0">
				<div class="modifyAvatar">
					<el-upload class="avatar-uploader" ref="headPort" :action="action" :show-file-list="true" :limit='1'
						list-type="picture-card" :on-success="headPortrait" :on-remove="avatarSmashing"
						style="width: 60px;height: 60px;border-radius: 100%;margin: 0 auto;text-align: center;"
						:headers="{token: token}">
						<img src="../assets/logo.png" alt=""
							style="width: 60px;height: 60px;border-radius: 100%;margin: 0 auto;text-align: center;"
							v-if="avatar==''||avatar==null" />
						<img :src="avatar" alt=""
							style="width: 60px;height: 60px;border-radius: 100%;margin: 0 auto;text-align: center;"
							v-if="avatar!=''&&avatar!=null" />
					</el-upload>
					<!-- <img src="../assets/logo.png" alt="" v-if="avatar==''||avatar==null" />
					<img :src="avatar" alt="" v-else /> -->
					<div>点击修改头像</div>
				</div>
				<div class="layoutContent">
					<div class="individualContent">
						<div class="title">姓名</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入您的姓名" v-model="realName" />
						</div>
					</div>
					<div class="individualContent">
						<div class="title">手机号</div>
						<div class="inputBox">
							<input type="number" maxlength="11" placeholder="请输入您的手机号" v-model="phone" />
						</div>
					</div>
				</div>
				<div class="layoutContent">
					<div class="individualContent">
						<div class="title">性别</div>
						<div class="inputBox" style="display: flex;align-items: center;margin-left: 62px;">
							<div class="ualGoals">
								<img src="../assets/icon/choice.png" alt="" v-if="gender==0" />
								<img src="../assets/icon/unchecked.png" alt="" v-else @click="genderSwitching(0)" />
								<div>女</div>
							</div>
							<div class="ualGoals">
								<img src="../assets/icon/choice.png" alt="" v-if="gender==1" />
								<img src="../assets/icon/unchecked.png" alt="" v-else @click="genderSwitching(1)" />
								<div>男</div>
							</div>
						</div>
					</div>
					<div class="individualContent">
						<div class="title">出生日期</div>
						<div class="inputBox" style="margin-left: 32px;">
							<el-date-picker v-model="birthday" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
								value-format="yyyy-MM-dd" @change="dateSelection">
							</el-date-picker>
						</div>
					</div>
				</div>
				<!-- <div class="layoutContent">
					<div class="individualContent">
						<div class="title">地址</div>
						<div class="inputBox" style="margin-left: 62px;">
							<el-cascader style="width: 100%;" placeholder="省/市/区" v-model="values"
								:props="{value:'label'}" :options="options" @change="handleChange"></el-cascader>
							
						</div>
					</div>
					<div class="individualContent">
						<div class="title">详细地址</div>
						<div class="inputBox">
							<input type="text" placeholder="请输入您的详细地址" v-model="addressDetails" />
						</div>
					</div>
				</div> -->
				<!-- <div class="idse">
					<div class="titleOfIdCard">上传您的身份证件<span>请上传身份证正反面照片</span></div>
					<div class="singleIdCard">
						<div>
							<el-upload class="avatar-uploader" ref="AvatarUpload" :action="action"
								:show-file-list="true" :limit='1' list-type="picture-card"
								:on-success="uploadFileportraitFace" :on-remove="handleRemoveportraitFace"
								style="width: 156px;height: 98px;" :headers="{token: token}">
								<img src="../assets/icon/frontOfIDCard.png" alt="" style="width: 156px;height: 98px;"
									v-if="cardBack==''" />
								<img :src="cardBack" alt="" style="width: 156px;height: 98px;" v-if="cardBack!=''" />
							</el-upload>
						</div>
						<div style="margin-left: 10px;">
							<el-upload class="avatar-uploader" ref="lEmblemFace" :action="action" :show-file-list="true"
								:limit='1' list-type="picture-card" :on-success="uploadFilenationalEmblemFace"
								:on-remove="handleRemovenationalEmblemFace" style="width: 156px;height: 98px;"
								:headers="{token: token}">
								<img src="../assets/icon/onTheBackOfTheIDCard.png" alt=""
									style="width: 156px;height: 98px;" v-if='cardFront==""' />
								<img :src="cardFront" alt="" style="width: 156px;height: 98px;" v-if="cardFront!=''" />
							</el-upload>
						</div>
					</div>
				</div> -->
				<div class="saveContent" @click="submitForReview">保存</div>
			</div>
			<div class="feedback" v-if="typeIndex==1">
				<div class="textBox">
					<textarea rows="10" placeholder="请输入您要反馈的问题（5-500字以内）" v-model="content" maxlength="500"></textarea>
				</div>
				<div class="screenshotDelisting">
					<div class="gatherTogether">请提供问题的截图和照片（选填）</div>
					<div class="uploadImage">
						<el-upload class="avatar-uploader" ref="feedbackheadPort" :action="action"
							:show-file-list="true" :limit='1' list-type="picture-card" :on-success="feedbackDiagram"
							:on-remove="feedbackSmashing" style="width: 76px;height: 76px;" :headers="{token: token}">
							<img src="../assets/icon/addPicture.png" alt="" style="width: 76px;height: 76px;"
								v-if="img==''" />
							<img :src="img" alt="" style="width: 76px;height: 76px;" v-if="img!=''" />
						</el-upload>
						<!-- <img src="../assets/icon/addPicture.png" alt="" /> -->
					</div>
				</div>
				<div class="contactInformation">
					<div class="aboveTheFace">联系方式</div>
					<div class="inputBox">
						<input type="text" maxlength="11" placeholder="请输入手机号" v-model="phones" />
						<img src="../assets/icon/empty.png" alt="" @click="phones=''" />
					</div>
				</div>
				<div class="subinions" @click="submitOpinions">提交反馈</div>
			</div>
			<div class="setContent" v-if="typeIndex==2">
				<div class="setHead">
					<div class="setUp">设置</div>
					<div class="protocolInformation">
						<div class="singleProtocol" :class="protocolSwitching==0?'actiser':''" @click="outOfStock(0)">
							关于平台</div>
						<div class="singleProtocol" :class="protocolSwitching==1?'actiser':''" @click="outOfStock(1)">
							用户协议</div>
						<div class="singleProtocol" :class="protocolSwitching==2?'actiser':''" @click="outOfStock(2)">
							隐私政策</div>
					</div>
				</div>
				<div class="contentDisplay" style="white-space: pre-wrap;">
					<!-- <p v-html="formattedText"></p> -->
					{{aboutThePlatform}}
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		baseURL
	} from "@/api/index";
	import {
		register,
		userInformation,
		modifyUser,
		opinionInterface,
		setContent,
		realNameRegistration
	} from "@/api/api.js"
	import {
		regionData
	} from 'element-china-area-data'
	export default {
		data() {
			return {
				typeIndex: 0,
				action: baseURL + "/common/upload",
				gender: 0,
				doYouWantToChoose: false,
				form: {},
				realName: "",
				phone: '',
				address: '',
				addressDetails: '',
				birthday: '',
				cardBack: '',
				cardFront: '',
				token: localStorage.getItem('token'),
				options: regionData,
				values: '',
				information: '',
				avatar: '',
				content: '',
				img: '',
				phones: "",
				protocolSwitching: 0,
				aboutThePlatform: ''
			}
		},
		created() {
			this.personalInformation()
			this.setUp()
		},
		methods: {

			outOfStock(i) {
				this.protocolSwitching = i
				this.setUp()
			},
			setUp() {
				setContent().then(res => {
					if (this.protocolSwitching == 0) {
						this.aboutThePlatform = res.data[8].value
					} else if (this.protocolSwitching == 1) {
						this.aboutThePlatform = res.data[5].value
					} else {
						this.aboutThePlatform = res.data[6].value
					}
				})

			},
			//反馈图片
			feedbackDiagram(res, fileList) {
				this.img = res.url
				this.$refs.feedbackheadPort.$children[1].$el.style.display = 'none'
			},
			feedbackSmashing(file, fileList) {
				this.img = ''
				this.$refs.feedbackheadPort.$children[1].$el.style.display = ''
			},
			//意见反馈
			submitOpinions() {
				if (this.content == '') {
					this.$message.error('请输入反馈的问题');
					return
				}
				if (this.phones == '') {
					this.$message.error('请输入手机号');
					return
				}
				const regex = /^1[3-9]\d{9}$/;
				if (!regex.test(this.phones)) {
					this.$message.error('手机号格式不正确');
					return
				}
				opinionInterface({
					img: this.img,
					content: this.content,
					phone: this.phones,
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						}, 1000);
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			//保存
			submitForReview() {
				// if (this.realName == '') {
				// 	this.$message.error('请输入姓名');
				// 	return
				// }
				// if (this.phone == '') {
				// 	this.$message.error('请输入手机号');
				// 	return
				// }
				// const regex = /^1[3-9]\d{9}$/;
				// if (!regex.test(this.phone)) {
				// 	this.$message.error('手机号格式不正确');
				// 	return
				// }
				// if (this.address == '') {
				// 	this.$message.error('请选择省市区');
				// 	return
				// }
				// if (this.addressDetails == '') {
				// 	this.$message.error('请输入详细地址');
				// 	return
				// }
				// if (this.birthday == '') {
				// 	this.$message.error('请选择出生日期');
				// 	return
				// }
				// if (this.cardBack == '') {
				// 	this.$message.error('请上传身份证人像面');
				// 	return
				// }
				// if (this.cardFront == '') {
				// 	this.$message.error('请上传身份证国徽面');
				// 	return
				// }
				// if (this.doYouWantToChoose == '') {
				// 	this.$message.error('请阅读并勾选《用户服务协议》与《隐私政策》');
				// 	return
				// }
				realNameRegistration({
					avatar: this.avatar,
					realName: this.realName,
					phone: this.phone,
					address: this.address,
					addressDetails: this.addressDetails,
					gender: this.gender,
					birthday: this.birthday,
					cardBack: this.cardBack,
					cardFront: this.cardFront,
				}).then(res => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							location.reload();
							this.personalInformation()
						}, 1000);
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			// 用户信息
			personalInformation() {
				userInformation().then(res => {
					this.information = res.data
					this.realName = res.data.realName
					this.phone = res.data.phone
					this.values = res.data.address != null ? res.data.address.split('-') : ''
					this.address = res.data.address != null ? res.data.address.split('-')[0] + '-' + res.data
						.address.split('-')[1] + '-' +
						res.data.address.split('-')[2] : ''
					this.addressDetails = res.data.addressDetails
					this.gender = res.data.gender
					this.birthday = res.data.birthday
					this.cardBack = res.data.cardBack
					this.cardFront = res.data.cardFront
					this.avatar = res.data.avatar
				})
			},
			//头像
			headPortrait(res, fileList) {
				this.avatar = res.url
				this.$refs.headPort.$children[1].$el.style.display = 'none'
			},
			avatarSmashing(file, fileList) {
				this.avatar = ''
				this.$refs.headPort.$children[1].$el.style.display = ''
			},
			//人像面
			uploadFileportraitFace(res, fileList) {
				console.log(res)
				this.cardBack = res.url
				this.$refs.AvatarUpload.$children[1].$el.style.display = 'none'
			},
			handleRemoveportraitFace(file, fileList) {
				this.cardBack = ''
				this.$refs.AvatarUpload.$children[1].$el.style.display = ''
			},
			//国徽面
			uploadFilenationalEmblemFace(res, fileList) {
				this.cardFront = res.url
				this.$refs.lEmblemFace.$children[1].$el.style.display = 'none'
			},
			handleRemovenationalEmblemFace(file, fileList) {
				this.cardFront = ''
				this.$refs.lEmblemFace.$children[1].$el.style.display = ''
			},
			//日期选择
			dateSelection(e) {
				this.birthday = e
				console.log(e)
			},
			// 省市区
			handleChange(value) {
				this.address = value[0] + value[1] + value[2]
				this.values = value
				console.log(value)
			},


			switchSelection() {
				this.doYouWantToChoose = !this.doYouWantToChoose
			},
			genderSwitching(i) {
				this.gender = i
			},
		}
	}
</script>

<style lang="scss" scoped>
	.modifyAvatar {
		margin: 0 auto;
		text-align: center;
		font-family: Source Han Sans CN, Source Han Sans CN;
		font-weight: 400;
		font-size: 13px;
		color: #777777;

		::v-deep .el-upload-list__item-status-label {
			display: none !important;
		}

		::v-deep .el-upload-list--picture-card {
			display: flex;
			width: 330px;
		}

		::v-deep .el-upload--picture-card {
			width: 60px;
			height: 60px;
			line-height: normal;
			border: none;
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item {
			width: 60px;
			height: 60px;
		}

		img {
			width: 60px;
			height: 60px;
			border-radius: 100%;
			margin-bottom: 10px;
		}
	}

	.classification {
		.singleType {
			width: 202px;
			height: 50px;
			background: #F1F1F1;
			border-radius: 0px 0px 0px 0px;
			line-height: 50px;
			padding-left: 18px;
			font-family: Microsoft YaHei, Microsoft YaHei;
			font-weight: 400;
			font-size: 15px;
			color: #333333;
		}

		.active {
			background: #D89A3A;
			color: #fff;
		}
	}

	.diagnosis {
		margin-left: 20px;
		padding: 50px 120px;
		// position: relative;
		flex: 1;
		cursor: default;
		background: #fff;
		margin-bottom: 50px;
	}

	.layoutContent {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 30px;

		.individualContent {
			width: 45%;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #E6E6E6;

			.title {
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #333333;
			}

			.inputBox {
				padding-top: 20px;
				padding-bottom: 20px;

				.ualGoals {
					display: flex;
					align-items: center;
					margin-right: 40px;

					img {
						margin-right: 10px;
						width: 15px;
						height: 15px;
					}
				}

				input {
					border: none;
					outline: none;
					box-shadow: none;
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #333;
					margin-left: 62px;
				}
			}
		}
	}

	.idse {
		margin-top: 20px;

		.titleOfIdCard {
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #333333;

			span {
				font-family: Source Han Sans CN, Source Han Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #ADAFB7;
				margin-left: 10px;
			}
		}

		.singleIdCard {
			display: flex;
			align-items: center;
			margin-top: 10px;

			::v-deep .el-upload-list__item-status-label {
				display: none !important;
			}

			::v-deep .el-upload-list--picture-card {
				display: flex;
				width: 330px;
			}

			::v-deep .el-upload--picture-card {
				width: 156px;
				height: 98px;
				line-height: normal;
				border: none;
			}

			::v-deep .el-upload-list--picture-card .el-upload-list__item {
				width: 156px;
				height: 98px;
			}

			div {
				width: 156px;
				height: 98px;

				img {
					width: 156px;
					height: 98px;
				}
			}
		}
	}

	.saveContent {
		width: 432px;
		height: 46px;
		background: linear-gradient(90deg, #ECBF85 0%, #D89A3A 100%);
		border-radius: 30px 30px 30px 30px;
		font-family: Microsoft YaHei, Microsoft YaHei;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
		line-height: 46px;
		margin: 0 auto;
		margin-top: 65px;
	}

	.feedback {
		margin-left: 20px;
		padding: 30px;
		flex: 1;
		cursor: default;
		background: #fff;
		margin-bottom: 50px;

		.textBox {
			background: #FAFAFA;
			border-radius: 5px 5px 5px 5px;
			padding: 14px 18px;

			textarea {
				background: #FAFAFA;
				border-radius: 5px 5px 5px 5px;
				background: none;
				border: none;
				outline: none;
				resize: none;
				width: 100%;
			}
		}

		.screenshotDelisting {
			background: #FAFAFA;
			border-radius: 5px 5px 5px 5px;
			padding: 0 15px;
			margin: 8px 0;

			.gatherTogether {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #333333;
				border-bottom: 1px solid #E6E6E6;
				padding: 14px 0;
			}

			.uploadImage {
				padding: 15px 0;

				::v-deep .el-upload-list__item-status-label {
					display: none !important;
				}

				// ::v-deep .el-upload-list--picture-card {
				// 	display: flex;
				// 	width: 330px;
				// }

				::v-deep .el-upload--picture-card {
					width: 76px;
					height: 76px;
					line-height: normal;
					border: none;
				}

				::v-deep .el-upload-list--picture-card .el-upload-list__item {
					width: 76px;
					height: 76px;
				}


				img {
					width: 76px;
					height: 76px;
				}
			}
		}

		.contactInformation {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 14px 15px;
			background: #FAFAFA;
			border-radius: 5px 5px 5px 5px;

			.aboveTheFace {
				font-family: PingFang SC, PingFang SC;
				font-weight: 500;
				font-size: 14px;
				color: #333333;
			}

			.inputBox {
				display: flex;
				align-items: center;

				img {
					width: 16px;
					height: 16px;
				}

				input {
					border: none;
					outline: none;
					box-shadow: none;
					background: #FAFAFA;
				}
			}
		}

		.subinions {
			width: 368px;
			height: 44px;
			background: linear-gradient(90deg, #ECBF85 0%, #D89A3A 100%);
			border-radius: 30px 30px 30px 30px;
			font-family: PingFang SC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			line-height: 44px;
			margin: 0 auto;
			margin-top: 50px;
		}
	}

	.setContent {
		margin-left: 20px;
		padding: 30px 0;
		flex: 1;
		cursor: default;
		background: #fff;
		margin-bottom: 50px;

		.setHead {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #E1E1E1;
			padding: 0 27px;

			.setUp {
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				padding-bottom: 16px;
				position: relative;
				text-align: center;
				width: 46px;
			}

			.setUp::after {
				content: "";
				position: absolute;
				width: 46px;
				height: 3px;
				background: #D89A3A;
				border-radius: 0px 0px 0px 0px;
				left: 0;
				right: 0;
				bottom: 0;
				top: 35px;
				margin: 0 auto;
				text-align: center;
			}

			.protocolInformation {
				display: flex;
				align-items: center;
				padding-bottom: 15px;

				.singleProtocol {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 16px;
					color: #666666;
					margin-left: 36px;
				}

				.actiser {
					color: #D89A3A;
				}
			}
		}

		.contentDisplay {
			font-family: PingFang SC, PingFang SC;
			font-weight: 500;
			font-size: 13px;
			color: #777777;
			padding: 30px 27px;
		}
	}
</style>